import type { QueryClient } from '@tanstack/react-query'
import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { getEnv } from '@unsw/config'
import { CrispChatWidget } from '@unsw/ui/components/composed/crisp-chat'
import { ErrorPage } from '@unsw/ui/components/composed/error-page'
import { NotFoundPage } from '@unsw/ui/components/composed/not-found-page'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: ({ reset }) => {
    return (
      <ErrorPage
        onRetry={reset}
        renderHomeLink={({ className, children }) => (
          <Link to="/dashboard" className={className}>
            {children}
          </Link>
        )}
        homeLinkLabel="Go to dashboard"
      />
    )
  },
  notFoundComponent: () => {
    return (
      <NotFoundPage
        renderHomeLink={({ className, children }) => (
          <Link to="/dashboard" className={className}>
            {children}
          </Link>
        )}
        homeLinkLabel="Go to dashboard"
      />
    )
  },
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <CrispChatWidget
        websiteID={getEnv().CRISP_WEBSITE_ID ?? ''}
        avatarURL="/melvin.svg"
        colorTheme="amber"
      />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}
